import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { MailIcon } from 'lucide-react';
export function Contact() {
  return <>
      <Helmet data-id="element-1393">
        <title data-id="element-1394">Contact Us | Bright Pixxel Studio</title>
        <meta name="description" content="Get in touch about web design, e-commerce or website care. We reply within 24 hours with friendly, honest advice. Start your free consultation." data-id="element-1395" />
        <link rel="canonical" href="https://bright-pixxel.com/contact" data-id="element-1396" />
        {/* Open Graph Meta Tags */}
        <meta property="og:locale" content="en_GB" data-id="element-1397" />
        <meta property="og:type" content="website" data-id="element-1398" />
        <meta property="og:title" content="Contact Us | Bright Pixxel Studio" data-id="element-1399" />
        <meta property="og:description" content="Get in touch about web design, e-commerce or website care. We reply within 24 hours with friendly, honest advice. Start your free consultation." data-id="element-1400" />
        <meta property="og:url" content="https://bright-pixxel.com/contact" data-id="element-1401" />
        <meta property="og:site_name" content="Bright Pixxel Studio" data-id="element-1402" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-1403" />
        <meta property="og:image:width" content="1200" data-id="element-1404" />
        <meta property="og:image:height" content="630" data-id="element-1405" />
        <meta property="og:image:type" content="image/png" data-id="element-1406" />
        <meta property="og:image:alt" content="Bright Pixxel Studio - Contact Us" data-id="element-1407" />
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-1408" />
        <meta name="twitter:title" content="Contact Us | Bright Pixxel Studio" data-id="element-1409" />
        <meta name="twitter:description" content="Get in touch about web design, e-commerce or website care. We reply within 24 hours with friendly, honest advice. Start your free consultation." data-id="element-1410" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-1411" />
        <meta name="twitter:image:alt" content="Bright Pixxel Studio - Contact Us" data-id="element-1412" />
      </Helmet>
      <section className="pt-32 pb-16 bg-white dark:bg-[#F5F5F5] min-h-screen" data-id="element-1413">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1414">
          <div className="max-w-6xl mx-auto" data-id="element-1415">
            {/* Header */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="text-center mb-12" data-id="element-1416">
              <h1 className="text-3xl md:text-5xl font-bold mb-4 text-[#0C1B26] dark:text-[#0C1B26]" data-id="element-1417">
                Contact Bright Pixxel Studio
              </h1>
              <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1418">
                We're here to help. Email us directly and we'll respond within
                24 hours.
              </p>
            </motion.div>
            {/* Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-1419">
              {/* Left: Illustration */}
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6
            }} className="order-2 lg:order-1" data-id="element-1420">
                <div className="relative bg-[#212C34] rounded-2xl p-8 md:p-12 shadow-lg" data-id="element-1421">
                  <div className="relative z-10" data-id="element-1422">
                    <img src="https://images.unsplash.com/photo-1596526131083-e8c633c948d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Contact us illustration - email communication" className="w-full h-auto rounded-lg" loading="eager" data-id="element-1423" />
                  </div>
                  {/* Decorative elements */}
                  <div className="absolute top-4 right-4 w-20 h-20 bg-[#0DC3DC]/20 rounded-full blur-2xl" data-id="element-1424"></div>
                  <div className="absolute bottom-4 left-4 w-32 h-32 bg-[#0DC3DC]/10 rounded-full blur-3xl" data-id="element-1425"></div>
                </div>
              </motion.div>
              {/* Right: Email Card */}
              <motion.div initial={{
              opacity: 0,
              x: 30
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="order-1 lg:order-2" data-id="element-1426">
                <div className="bg-[#212C34] rounded-2xl p-8 md:p-10 shadow-xl" data-id="element-1427">
                  {/* Email Icon */}
                  <div className="w-16 h-16 bg-[#0DC3DC]/20 rounded-full flex items-center justify-center mb-6" data-id="element-1428">
                    <MailIcon size={32} className="text-[#0DC3DC]" data-id="element-1429" />
                  </div>
                  {/* Email Address */}
                  <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-1430">
                    Email Us
                  </h2>
                  <a href="mailto:info@bright-pixxel.com" className="text-xl md:text-2xl text-[#0DC3DC] hover:text-[#0DC3DC]/80 transition-colors mb-6 block break-all" data-id="element-1431">
                    info@bright-pixxel.com
                  </a>
                  {/* Send Email Button */}
                  <div className="flex flex-col gap-4 mb-6" data-id="element-1432">
                    <a href="mailto:info@bright-pixxel.com?subject=Website Enquiry - Bright Pixxel Studio" className="w-full inline-flex items-center justify-center bg-[#0DC3DC] hover:bg-[#0DC3DC]/90 text-white px-8 py-4 rounded-lg font-bold transition-all duration-300 shadow-lg hover:shadow-[0_0_20px_rgba(13,195,220,0.4)]" data-id="element-1433">
                      <MailIcon size={20} className="mr-2" data-id="element-1434" />
                      Send Email
                    </a>
                    <a href="https://wa.me/447000000000" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center bg-[#25D366] hover:bg-[#128C7E] text-white px-8 py-4 rounded-lg font-bold transition-all duration-300 shadow-lg" data-id="element-1435">
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-1436">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" data-id="element-1437" />
                      </svg>
                      WhatsApp Us
                    </a>
                  </div>
                  {/* Working Hours */}
                  <div className="pt-4 border-t border-white/10" data-id="element-1438">
                    <p className="text-white/90 text-sm mb-2 font-semibold" data-id="element-1439">
                      Working Hours
                    </p>
                    <p className="text-white/70 text-sm mb-1" data-id="element-1440">
                      Monday – Friday: 9:00 AM – 5:00 PM (UK time)
                    </p>
                    <p className="text-white/70 text-sm mb-3" data-id="element-1441">
                      Saturday & Sunday: Closed
                    </p>
                    <p className="text-[#0DC3DC] text-sm font-medium" data-id="element-1442">
                      ✓ We reply to all emails within 24 hours
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </>;
}